import React from 'react';
import { Box, Typography } from '@mui/material';
import { currency, productListPrice, productOnSale, productUnitPrice } from './Currency';
import { lead600, lead900 } from '../../theme/colors';

const ProductPriceDisplay = ({ product, compact = false, textAlign = 'left', sx = {} }) => {
  const onSale = productOnSale(product);
  const unitPrice = productUnitPrice(product);
  const listPrice = productListPrice(product);
  const discountPercent = product.discount_percent || Math.round((1 - unitPrice / listPrice) * 100);

  if (!onSale) {
    return (
      <Typography
        variant="body1"
        textAlign={textAlign}
        sx={{ fontFamily: 'Nunito', fontWeight: 700, lineHeight: '21px', fontSize: '14px', color: lead600, ...sx }}
      >
        {currency(unitPrice)}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: compact ? 'row' : 'column',
        alignItems: compact ? 'center' : 'flex-start',
        gap: compact ? 0.75 : 0.25,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Typography
          component="span"
          sx={{
            bgcolor: 'success.light',
            color: lead900,
            borderRadius: '4px',
            px: 0.5,
            py: 0.1,
            fontFamily: 'Nunito',
            fontSize: '12px',
            fontWeight: 800,
            lineHeight: '18px',
          }}
        >
          -{discountPercent}%
        </Typography>
        <Typography
          component="span"
          sx={{
            color: 'text.secondary',
            fontFamily: 'Nunito',
            fontSize: '12px',
            fontWeight: 700,
            lineHeight: '18px',
            textDecoration: 'line-through',
          }}
        >
          {currency(listPrice)}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        textAlign={textAlign}
        sx={{ fontFamily: 'Nunito', fontWeight: 800, lineHeight: '21px', fontSize: '14px', color: 'success.dark' }}
      >
        {currency(unitPrice)}
      </Typography>
    </Box>
  );
};

export default ProductPriceDisplay;
